import { createApi } from './api';
export function create(_ref) {
  let {
    httpClient
  } = _ref;
  const {
    getSimilarBoughtCars
  } = createApi(httpClient);
  return {
    getSimilarBoughtCars
  };
}